import $ from 'jquery';
//const eventBus = require('./event-bus');
import debounce from 'debounce';
// Resize to another device format on the fly
//--------------------------------------------
'use strict';

var screens = {
  xs: [null, 767],
  sm: [768, 992],
  md: [992, 1199],
  lg: [1200, null]
};

var currentScreen = null;

$(function () {
  // (private) Global variables
  var $window = $(window);

  function setCurrentScreen() {
    var width = $window.width(), arr;

    for (var x in screens) {
      if (!screens.hasOwnProperty(x)) {
        continue;
      }

      arr = screens[x];
      if (arr[0] && arr[0] > width) {
        continue;
      }
      else if (arr[1] && arr[1] < width) {
        continue;
      }

      if (currentScreen !== x) {
        currentScreen = x;
        //eventBus.trigger('screen_change', [currentScreen]);
        break;
      }
    }
  }

  setCurrentScreen();
  $window.on('resize', debounce(setCurrentScreen, 200));
});

export default function getCurrentScreenSize() {
  return currentScreen;
};
